import { CustomNode } from '../../../types';
import { abSplitIcon } from '../../../icons';

const DEFAULT_ICON = abSplitIcon;

export const abSplitConfig: CustomNode = {
  getNodeConfig() {
    return {
      icon: DEFAULT_ICON,
    };
  },
};
